import { MEDIA_DATA } from 'routes/media/constants/media-data.constant';

import Button from 'components/buttons/Button';

import { ReactComponent as Download } from 'assets/icons/download.svg';
import MediaContactPerson from 'assets/media/media-contact-person.png';

import styles from './MediaContact.module.scss';

const MediaContact = () => (
  <div className="tw-flex tw-flex-col tw-items-center tw-bg-darkBlue tw-py-[50px] sm:tw-pb-[120px] sm:tw-pt-[100px]">
    <h2 className="tw-flex-col tw-pb-[60px] tw-text-center tw-text-[32px] tw-font-bold tw-uppercase tw-text-white sm:tw-text-5xl">
      Contact Persons
    </h2>
    <div className="tw-flex tw-items-start tw-justify-center tw-gap-4 sm:tw-gap-5">
      <img src={MediaContactPerson} alt="contact person" className="tw-w-[64px] sm:tw-w-[100px]" />
      <div className="tw-flex tw-flex-col tw-items-start tw-justify-center">
        <p className="tw-text-xl tw-text-white sm:tw-text-2xl">Stanislav Poleheshko</p>
        <p className="tw-text-base tw-text-skyBlue sm:tw-text-lg">Community Team Leader and Business Development</p>
        <a className="tw-text-base tw-text-turquoise sm:tw-text-lg" href="mailto:stanislav.poleheshko@realitymeta.io">
          stanislav.poleheshko@realitymeta.io
        </a>
      </div>
    </div>
    <Button
      className={styles['download-button']}
      iconComponentRight={<Download />}
      asLink
      size="medium"
      color="default"
      link={MEDIA_DATA.kitToDownload.url}
    >
      Download press kit
    </Button>
  </div>
);

export default MediaContact;
